import { render, staticRenderFns } from "./HumanMachineCollaborationSection.vue?vue&type=template&id=fd624ac4&scoped=true"
import script from "./HumanMachineCollaborationSection.vue?vue&type=script&lang=js"
export * from "./HumanMachineCollaborationSection.vue?vue&type=script&lang=js"
import style0 from "./HumanMachineCollaborationSection.vue?vue&type=style&index=0&id=fd624ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd624ac4",
  null
  
)

export default component.exports